module.exports = __webpack_public_path__ + "img/logo6.75a23310.png";